import { IAccount } from '../../types';
import { action, observable, makeObservable } from 'mobx';

export default class LocationStore {
    location: any = {
        id: ''
    };

    constructor(location: IAccount) {
        makeObservable(this, {
            location: observable,
            update: action
        });

        this.update(location);
    }

    update(location: IAccount): void {
        this.location = {
            ...this.location,
            ...location
        };
    }
}
